import React from 'react'

import styles from './styles.module.scss'

const statusMap = {
  available: {
    background: '#D1F9CB',
    text: '#32BF1F',
    border: '#BEF3B7',
    title: 'Available',
  },
  maintenance: {
    background: '#FFD4A5',
    text: '#D77000',
    border: '#E7C88C',
    title: 'Maintenance',
  },
  reserved: {
    background: '#f5f3ff',
    text: '#7f22fe',
    border: '#e9e2e4',
    title: 'Reserved',
  },
  assigned: {
    background: '#ECF0FF',
    text: '#6D75E8',
    border: '#D3D6FA',
    title: 'Assigned',
  },
  damaged: {
    background: '#FFBDBD',
    text: '#D70000',
    border: '#F77C7C',
    title: 'Damaged',
  },
  lost: {
    background: '#FFBDBD',
    text: '#D70000',
    border: '#F77C7C',
    title: 'Lost',
  },
  default: {
    background: '#E9E9E9',
    text: '#919191',
    border: '#C6C6C6',
  }
}

const getStatusStyles = status => {
  const colors = statusMap[status] || statusMap.default
  return {
    backgroundColor: colors.background,
    color: colors.text,
    border: `1px solid ${colors.border}`,
  }
}

const AssetStatus = ({status}) => {
  const colors = getStatusStyles(status)
  return (
    <div className={styles.container} style={colors}>
      <div className={styles.dot} style={{backgroundColor: colors.color}} />
      <div className={styles.text}>{statusMap[status]?.title || ''}</div>
    </div>
  )
}

export default AssetStatus
